import { useCallback, useState } from "react";

type StorageType = "cookie" | "local" | "session";

function getStorage(key: string, type: StorageType): string | undefined {
    switch(type) {
        case "cookie":
            return document.cookie
            .split("; ")
            .find(row => row.startsWith(`${key}=`))
            ?.split("=")[1] ?? getStorage(key, "local");
        case "local":
            return localStorage.getItem(key) ?? getStorage(key, "session");
        case "session":
            return sessionStorage.getItem(key) ?? undefined;
    }
}

function setStorage(key: string, type: StorageType, value: string) {
    switch(type) {
        case "cookie":
            document.cookie = `${key}=${value}; SameSite=None; Secure`;
            break;
        case "local":
             localStorage.setItem(key, value);
             break;
        case "session":
            sessionStorage.setItem(key, value);
            break;
    }
}

function removeStorage(key: string, type: StorageType) {
    switch(type) {
        case "cookie":
            document.cookie = `${key}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
            break;
        case "local":
             localStorage.removeItem(key);
             break;
        case "session":
            sessionStorage.removeItem(key);
            break;
    }
}

export function useRememberFormValues<TStore>(key: string, storage: StorageType = "session"): [TStore | undefined, (newValues?: TStore, storage?: StorageType) => void] {
    const [value, setStateValue] = useState<TStore | undefined>(()=> {
        const json = getStorage(key, storage);
        if(json) {
            try {
        return JSON.parse(json) as TStore
            } catch (_) { /* empty */ }
        }
        return undefined;
    });

    const setStorageValue = useCallback((newValue?: TStore, innerStorage: StorageType = storage)=>{
        if(newValue) {
            setStorage(key, innerStorage, JSON.stringify(newValue));
        } else {
            removeStorage(key, innerStorage);
        }
        setStateValue(newValue);
    },[key, storage])

    return [value, setStorageValue];
}